import { useTranslation } from 'react-i18next';
import { consultationFeatures } from '@/mocks/consultationData';

export default function ConsultationFeatures() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('consultation.features.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('consultation.features.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('consultation.features.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-5"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('consultation.features.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {consultationFeatures.map((feature, idx) => (
            <div
              key={idx}
              className="card-glow group bg-background-50 border border-background-200/60 p-6 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-accent-500/[0.06] group-hover:bg-accent-500/[0.1] transition-colors duration-300">
                <i className={`${feature.icon} text-accent-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-[16px] md:text-[17px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                {t(`consultation.features.item.${idx}.title`)}
              </h3>
              <p className="text-accent-500 text-[13px] tracking-[0.1em] mb-3 font-label">
                {feature.titleEn}
              </p>
              <p className="text-[14px] md:text-[15px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t(`consultation.features.item.${idx}.desc`)}
              </p>
            </div>
          ))}
        </div>

        {/* Free notice */}
        <div className="mt-10 text-center">
          <p className="inline-block text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed px-6 py-3 border border-accent-500/20 bg-accent-500/[0.03]">
            {t('consultation.features.freeNote')}
          </p>
        </div>
      </div>
    </section>
  );
}
